import {cloneDeep} from "lodash";

class Questionario {
  /**
   * RecursiveElement  = usato per storare temporaneamente l'oggetto
   * ElemetFounded     = usato per storare temporaneamente l'elemento trovato
   * ExitFromRecursive = usato per storare temporaneamente se deve uscire dal recursive loop
   */
  constructor() {
    this.recursiveElement = null;
    this.elementFounded = null;
    this.exitFromRecursive = false;
  }

  /**
   * Init Questionario
   * - Aggiunge Hash sia ai componenti semplici che a quelli logici
   * @param questionario
   * @returns {*}
   */
  _init(questionario, init) {
    let that = this;
    let elementReturned = null;
    this.elementFounded = null;
    this.exitFromRecursive = false;
    let questionarioJSON = cloneDeep(questionario);

    if (questionarioJSON.length > 0) {
      questionarioJSON.forEach(function (item, index) {
        that.recursiveElement = [];
        questionarioJSON[index] = that._recursiveLoop('init',item, init)[0];
      });
    }

    return questionarioJSON;
  }

  _composeQuestionarioFlat(elements) {
    let questionarioFlat = [];
    let that = this;
    if (elements.length > 0) {
      elements.forEach(function (item, index) {
        let componentFlat = cloneDeep(item);
        delete componentFlat.slots;
        questionarioFlat.push(componentFlat);
        recursiveFlat(item, questionarioFlat);
      });
    }

    function recursiveFlat(element, questionarioFlat) {
      if (element.slots) {
        Object.keys(element.slots).forEach(function (item, index = null) {
          if (element.slots[item]) {
            for (let k = 0; k < Object.keys(element.slots[item]).length; k++) {
              if (element.slots[item][k].type !== 'component') {
                questionarioFlat.push(element.slots[item][k]);
              } else {
                recursiveFlat(element.slots[item][k], questionarioFlat);
              }
            }
          }
        });
      }else {
        questionarioFlat.push(element);
      }
    }

    return questionarioFlat;
  }

  _fillQuestionario(risposte, questionario) {
    delete risposte.esito;
    delete risposte.message;
    let that = this;

    if (Object.keys(risposte).length > 0) {
      Object.keys(risposte).forEach(function (key) {
        if(risposte[key].hash_domanda) {
          let element = that._searchByHash(questionario, {el:{hash:risposte[key].hash_domanda}});
          if(!element.label) {
            fallco.console.error('Alla domanda manca la label: ', "questionario",questionario, "element", element, "riposta[key]", risposte[key], "risposte", risposte, key);
          }

          element['required'] = true;
          if(risposte[key].risposta != '' && risposte[key].risposta != null && risposte[key].risposta != undefined) {
            element.value = risposte[key].risposta;
            element.risposta_id = risposte[key].risposta_id;
            element.is_accettato = risposte[key].is_accettato;
            element.is_blocked = risposte[key].is_blocked;
          } else if(risposte[key].documento_id != '' && risposte[key].documento_id != null && risposte[key].documento_id != undefined){
            if (!element.value) {
              element.value = [];
            }

            if(risposte[key].filesystem_name !== null) {
              element.value.push(risposte[key]);
            }

            if(risposte[key].is_accettato === 0) {
              element.enabled = 'true';
            }

            if(!element.enabled && risposte[key].is_accettato === 1) {
              element.enabled = 'false';
            }
          }
        }else {
          fallco.console.error("HASH NON TROVATO",risposte[key], key)
        }
      });
    }

    return questionario;
  }

  /**
   * Metodo per rimuovere elementi dal JSON
   * Elementi che si possono eliminare:
   * - componenti semplici
   * - slot
   * - componenti logici
   * Si possono eliminare solo i componenti che non hanno figli
   * @param questionario
   * @param element
   * @returns {*}
   * @private
   */
  _removeElement(questionario, element) {
    let elementReturned = null;
    let that = this;
    this.elementFounded = null;
    this.exitFromRecursive = false;
    questionario.forEach(function (item, index) {
      // Controllo se l'hash corrisponde e non ho la key (usata per eliminare gli slot)
      // Elimina tutti gli elementi di primo livello
      if(item.hash && item.hash == element.el.hash && !element.key) {
        questionario.splice(index, 1);
      } else {
        // else chiama il metodo ricorsivo
        elementReturned = that._recursiveLoop('removeElement',item, false, true, element.el.hash, true, element.key);
      }
    });
    return questionario;
  }

  /**
   * Aggiungi Note ad Elemento del Questionario
   * @param questionario
   * @param element
   * @returns {*}
   */
  _aggiungiNote(questionario, element) {
    let returned = this._searchByHash(questionario, element);
    if(returned.hash) {
      returned.note = element.value;
    }else {
      console.error("NON MATCH", returned)
    }

    return questionario;
  }

  /**
   * Ricerca Elemento By HASH
   * @param questionario
   * @param element
   * @returns {null}
   */
  _searchByHash(questionario, element) {
    // element {el:element, key: ''}
    // se è uno slot ha una key
    let that = this;
    let elementReturned = null;
    this.elementFounded = null;
    this.exitFromRecursive = false;
    questionario.forEach(function (item, index) {
      that.recursiveElement = [];
      elementReturned = that._recursiveLoop('searchByHash',item, false, true, element.el.hash);
    });

    return elementReturned;
  }

  /**
   * TODO: sono stato obbligato ad introdurre dei cambiamenti,
   * TODO: quando poi si ri-svilupperà l'admin lato notaio bisogna verificare aggiunta note e eliminazione voci
   * TODO: che continuino a funzionare
   * Metodo che scorre ricorsivamente il JSON
   * @param {Object}  element    - elemento da analizzare
   * @param {boolean} init      - se true siamo nella fase di init della classe
   * @param {boolean} search    - se true devo avviare una ricerca mentre scorro
   * @param {string}  hash       - valore dell'hash da ricercare
   * @param {boolean} remove     - se true devo eliminare quello con matcha con la ricerca
   * @param {string}  removeKey   - se popolata indica quale slot devo rimuovere
   * @returns {null|*|[]}
   */
  _recursiveLoop(origin, element, init = false, search = false, hash = null, remove = false, removeKey = null) {
    let that = this;
    // forza l'uscita dal metodo
    if (that.exitFromRecursive) {
      return that.elementFounded;
    }

    if (element.hash == hash && !element.key && !init && search) {
      that.elementFounded = element;
      that.exitFromRecursive = true;
      return element;
    }

    if (element.slots) {
      (init) ? that._setHash(element) : that.recursiveElement.push(element);
      // controlla se deve eliminare uno slot
      if(removeKey) {
        if(element.hash == hash) {
          delete element.slots[removeKey];
          that.exitFromRecursive = true;
          that.elementFounded = element;
          return element;
        }
      }
      // Ciclo slots
      Object.keys(element.slots).forEach(function (item, index = null) {
        // forza l'uscita dal ciclo
        if (that.exitFromRecursive) {
          return that.elementFounded;
        }
        // Controllo se trova lo slot o != null
        if (element.slots[item]) {
          for (let k = 0; k < Object.keys(element.slots[item]).length; k++) {
            if (that.exitFromRecursive) {
              return that.elementFounded;
            }
            // controllo se l'elemento è un componente semplice
            if (element.slots[item][k].type !== 'component') {
              // se sono in fase di ricerca controllo il match
              if (search) {
                if (element.slots[item][k].hash == hash) {
                  // se sono in fase di remove elimino l'elemento matchato con la ricerca
                  if(remove) { element.slots[item].splice(k, 1); }
                  that.exitFromRecursive = true;
                  that.elementFounded = element.slots[item][k];
                  break;
                }
              }
              (init) ? that._setHash(element.slots[item][k]) : that.recursiveElement.push(element.slots[item][k]);
            } else {
              // else è un componente logico
              if (search) {
                // TODO: probabile non serva più (da verificare)
                if (element.hash == hash) {
                  that.exitFromRecursive = true;
                  that.elementFounded = element;
                  break;
                }
              }

              // se sono in fase di remove, ottengo un match dalla ricerca e non sto cercando di cancellare uno slot
              // in questa casistica sto rimuovendo un componente logico probabile all'interno di un altro componente logico
              if(remove && (element.slots[item][k].hash == hash) && !removeKey) {
                that.exitFromRecursive = true;
                element.slots[item].splice(k, 1);
                that.elementFounded = element;
                break;
              }
              // else è un componente logico, chiamo ricorsivamente il metodo
              (init) ? that._setHash(element.slots[item][k]) : that.recursiveElement.push(element.slots[item][k]);

              // se è un componente logico e non sto cercando di rimuoverlo, ciclo ricorsivamente il contenuto
              that._recursiveLoop(origin,element.slots[item][k], init, search, hash, remove, removeKey)
            }
          }
        }
      });
    } else {
      // else è un componente semplice
      if (init) {
        that._setHash(element)
      } else {
        that.recursiveElement.push(element);
      }
      // se sono in fase di ricerca controllo il match
      if (search) {
        if (element.hash == hash) {
          that.elementFounded = element;
          that.exitFromRecursive = true;
          return element;
        }
      }
    }

    return that.recursiveElement;
  }

  /**
   * Set Hash By Element
   * @param element
   * @private
   */
  _setHash(element) {
    element.hash = this._generateHash();
    element.required = true;
    element.novalidate = true;
    element.value = null;
    this.recursiveElement.push(element);
  }

  /**
   * Genero Hash
   * @returns {string}
   */
  _generateHash() {
    return Math.random().toString(36).substring(2, 5) + Math.random().toString(36).substring(2, 5);
  }
}


export default new Questionario();